import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-plandetails-showcase',
  templateUrl: './plandetails-showcase.component.html',
  styleUrls: ['./plandetails-showcase.component.scss']
})
export class PlandetailsShowcaseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
